import * as React from "react";
import {
    StoredTimeEntry,
    timeEntryFromStored,
    timeEntryToString,
} from "../../domain/timing";
import { pipe } from "fp-ts/function";

interface Props {
    value: StoredTimeEntry;
}

export const TimeEntryView = (p: Props) => {
    return pipe(p.value, timeEntryFromStored, timeEntryToString, (s) => (
        <span>{s}</span>
    ));
};
